export const escapeTildeCodeFencesForPreview = (content: string): string =>
  content.replace(/^([ \t]{0,3})~~~~[ \t]*$/gm, "$1\\~~~~")
